import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlueFace = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5256_62784)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
				fill: "#1DBADF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.2668 19.8895C14.2668 22.5275 12.1287 24.6686 9.48764 24.6686C6.84653 24.6686 4.7085 22.5306 4.7085 19.8895C4.7085 17.2484 6.8496 15.1104 9.48764 15.1104C12.1257 15.1104 14.2668 17.2515 14.2668 19.8895Z",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.34986 18.0399C9.34986 18.816 8.72102 19.4448 7.94495 19.4448C7.16887 19.4448 6.54004 18.816 6.54004 18.0399C6.54004 17.2638 7.16887 16.635 7.94495 16.635C8.72102 16.635 9.34986 17.2638 9.34986 18.0399Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8897 20.2546C10.8897 20.7025 10.5277 21.0645 10.0798 21.0645C9.63198 21.0645 9.27002 20.7025 9.27002 20.2546C9.27002 19.8068 9.63198 19.4448 10.0798 19.4448C10.5277 19.4448 10.8897 19.8068 10.8897 20.2546Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.2883 19.8895C43.2883 22.5275 41.1472 24.6686 38.5091 24.6686C35.8711 24.6686 33.73 22.5306 33.73 19.8895C33.73 17.2484 35.8711 15.1104 38.5091 15.1104C41.1472 15.1104 43.2883 17.2515 43.2883 19.8895Z",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.3679 18.0399C38.3679 18.816 37.7391 19.4448 36.963 19.4448C36.1869 19.4448 35.5581 18.816 35.5581 18.0399C35.5581 17.2638 36.1869 16.635 36.963 16.635C37.7391 16.635 38.3679 17.2638 38.3679 18.0399Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.9082 20.2546C39.9082 20.7025 39.5462 21.0645 39.0984 21.0645C38.6505 21.0645 38.2886 20.7025 38.2886 20.2546C38.2886 19.8068 38.6505 19.4448 39.0984 19.4448C39.5462 19.4448 39.9082 19.8068 39.9082 20.2546Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.62 27.2882C28.8316 29.6839 26.5954 31.3312 24.0801 31.3956C21.5709 31.46 19.2273 29.8404 18.3715 27.4876C18.2335 27.1072 17.8715 26.8526 17.4543 26.9661C17.0862 27.0674 16.7948 27.4999 16.9329 27.8833C18.0279 30.8925 20.8623 32.914 24.077 32.8864C27.2672 32.8588 30.0709 30.6809 31.0556 27.6839C31.3562 26.7668 29.9175 26.3772 29.6169 27.2882",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9204 28.7423C12.9204 30.0859 11.4572 31.1748 9.65045 31.1748C7.8437 31.1748 6.37744 30.0859 6.37744 28.7423C6.37744 27.3988 7.8437 26.3098 9.65045 26.3098C11.4572 26.3098 12.9204 27.3988 12.9204 28.7423Z",
				fill: "#FF2180"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.6196 28.7423C41.6196 30.0859 40.1564 31.1748 38.3497 31.1748C36.5429 31.1748 35.0767 30.0859 35.0767 28.7423C35.0767 27.3988 36.5429 26.3098 38.3497 26.3098C40.1564 26.3098 41.6196 27.3988 41.6196 28.7423Z",
				fill: "#FF2180"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5256_62784",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}) })]
});
export default SvgBlueFace;
